<template>
  <div v-cloak  v-loading.fullscreen.lock="dataLoading"
       element-loading-text="Loading, please wait..."
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)">

    <el-dialog
      title="Modify Abstract Tag"
      :visible.sync="editDialogVisible"
      :close-on-click-modal="false"
      @opened="opened"
      :center="true"
      width="500px"
      size="small">

      <el-form
        label-position="right"
        label-width="120px"
      >
        <el-form-item label="Tag: "  required>
          <el-input v-model="copyEditAbstractTagDO.tagName" size="small" ></el-input>
        </el-form-item>
        <el-form-item label="Description: " >
          <el-input v-model="copyEditAbstractTagDO.description" size="small" ></el-input>
        </el-form-item>
<!--        <el-form-item label="Is Biz Type: " >-->
<!--          <el-switch-->
<!--            v-model="copyEditAbstractTagDO.isService"-->
<!--            active-color="#13ce66"-->
<!--            inactive-color="#ff4949"-->
<!--            :active-value="true"-->
<!--            :inactive-value="false">-->
<!--          </el-switch>-->
<!--        </el-form-item>-->

      </el-form>

      <span slot="footer" class="dialog-footer">
              <el-button type="success" @click="save">Save</el-button>
              <el-button @click="editDialogVisible = false">close</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import util from '@/util/util.js'

  export default {
    components: {

    },
    props:  {
      editAbstractTagDO: {
        type: Object,
        required: true,
        default:() => {}
      }
   },
    data(){
      return{
        editDialogVisible: false,
        dataLoading: false,
        copyEditAbstractTagDO:{}
      }
    },
    computed: {
    },
    created(){
    },


    methods: {
      opened(){
        this.copyEditAbstractTagDO = util.deepClone(this.editAbstractTagDO);
      },
      showDialog(){
        this.editDialogVisible = true;


      },

      hideDialog(){
        this.editDialogVisible = false;
      },
      save(){

        let url = this.baseAcsUrl + '/acs/data-abstract-tag/update';

        if(!this.copyEditAbstractTagDO.tagName){
          this.$message.warning("tagName can't be empty");
          return;
        }
        this.dataLoading = true;

        this.http.put(url,this.copyEditAbstractTagDO).then(resp =>{
          this.$message.success('Successful operation ');
          this.editDialogVisible = false;
          this.dataLoading = false;
          this.$emit("saveSuccess");
        }).catch(error => {
          this.dataLoading = false;
          console.info(error);
          this.$emit("saveFail");

        });
      }
    }
  }

</script>

<style lang="scss" scoped>
  [v-cloak] {
    display: none;
  }
  .breadcrumb{
    background-color: transparent !important;
    margin-bottom: 0px;
  }
  .title{
    margin-left: 16px;
    font-size: 20px;
  }
 .el-form-item /deep/ .el-select{
   display: inline-block;
   width: 86%;
  }
  .add-banner-group  /deep/ .el-form-item__label{
    width: 148px !important;
  }
  .add-banner-group /deep/ .el-form-item__content{
    margin-left: 148px!important;
  }
</style>



// WEBPACK FOOTER //
// src/view/acs/tag/dialog/edit_abstract_tag.vue